
export const SET_SELECTED_ORDER= 'SET_SELECTED_ORDER'
export const SET_SELECTED_ORDER_SUCCESS= 'SET_SELECTED_ORDER_SUCCESS'
export const SET_SELECTED_ORDER_ERROR='SET_SELECTED_ORDER_ERROR'


export const SetSelectedOrder= (data) => ({
    type: SET_SELECTED_ORDER,
    payload: data
})
